<div
  (click)="imageClick(0)"
  class="innerBanner"
  [style.background-image]="
    islandsBannerAndContent.bannerImage
      ? 'url(' + islandsBannerAndContent.bannerImage + ')'
      : 'url(' + '../../../assets/images/NoImage.jpg' + ')'
  "
>
  <div class="bannerText">
    <h1>{{ islandsBannerAndContent.bannerTitle }}</h1>
  </div>
</div>

<p-galleria
  [(value)]="images"
  [(visible)]="displayCustom"
  [(activeIndex)]="activeIndex"
  [fullScreen]="true"
  [showItemNavigators]="false"
  [baseZIndex]="100000"
  [containerStyle]="{ 'max-width': '90%' }"
>
  <ng-template pTemplate="item" let-item>
    <img [src]="item" class="gallery-image" />
  </ng-template>
</p-galleria>

<!-- <app-breadcrumb></app-breadcrumb> -->
<app-breadcrumb-row></app-breadcrumb-row>
<div class="container">
  <div class="contentPanel mt-2">
    <p [innerHTML]="islandsBannerAndContent.content"></p>
    <p>&nbsp;</p>
  </div>
  <div class="highlightSection">
    <h1 class="text-center" [innerHTML]="islandTitle"></h1>
    <div class="popular-items">
      <p-carousel
        [value]="islandsGroups"
        styleClass="custom-carousel"
        [numVisible]="4"
        [numScroll]="1"
        [circular]="true"
        [responsiveOptions]="responsiveOptions"
        class="islands-carousel"
        [ngClass]="this.language"
      >
        <ng-template let-product pTemplate="item">
          <div class="product-item slider-arrow">
            <a href="javascript:void(0)" (click)="islandsDetails(product)">
              <div class="product-item-content">
                <div class="image">
                  <img
                    [src]="product.uri ? product.uri : '../../../assets/images/NoImage.jpg'"
                    [alt]="product.name"
                    class="product-image slider-image"
                  />
                </div>
                <div class="title">
                  <h3>{{ product.title }}</h3>
                </div>
              </div>
            </a>
          </div>
        </ng-template>
      </p-carousel>
    </div>
    <div class="viewall-btn">
      <a (click)="islandsAllGroups()">{{ 'View All' | translate }}<i class="pi pi-angle-right"></i></a>
    </div>
  </div>
</div>
